<div class="notification-center">
  <div class="notification-center-list">
    <div class="notification-center-filter">
      <dmb-button
        type="button"
        (buttonClick)="onlyNew.set(false)"
        i18n="@@user-settings.notification-center.all"
        [class.selected]="!onlyNew()"
        >All</dmb-button
      >
      <dmb-button
        type="button"
        (buttonClick)="onlyNew.set(true)"
        i18n="@@user-settings.notification-center.new"
        [class.selected]="onlyNew()"
        >New</dmb-button
      >
    </div>

    @if (filteredNotifications(); as fn) {
      @for (notification of fn; track notification.id) {
        <dmb-notification-center-item [item]="notification" />
      }
    } @else {
      <dmb-inline-spinner />
    }
  </div>
</div>
